import { Avatar as MuiAvatar } from '@mui/material'

import { rgba } from '../functions/colorUtils'

function AppAvatar({
  children,
  color = '#3B82F6',
  variant = 'solid',
  shape = 'square',
  size = 34,
  fontSize,
  fontWeight = 700,
  sx = {},
  ...rest
}) {
  const safeColor = color || '#3B82F6'
  const isLight = variant === 'light'

  const bgColor = isLight ? rgba(safeColor, 0.15) : safeColor
  const fgColor = isLight ? safeColor : '#ffffff'

  const dimension =
    typeof size === 'number' ? { width: size, height: size } : { width: size, height: size }

  const radius = shape === 'rounded' ? '50%' : '8px'

  return (
    <MuiAvatar
      variant="rounded"
      sx={{
        ...dimension,
        bgcolor: bgColor,
        color: fgColor,
        borderRadius: radius,
        fontSize: fontSize ?? Math.max(11, Math.round((dimension.width || 34) * 0.36)),
        fontWeight,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiAvatar>
  )
}

export default AppAvatar
export { AppAvatar }
